import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogBody,
} from "@/components/ui/alert-dialog";
import { useDeleteApiKey } from "@/hooks/useApiKeyMutations";
import { toast } from "sonner";

interface DeleteApiKeyDialogProps {
  open: boolean;
  onClose: () => void;
  apiKeyId: string;
  apiKeyName: string;
}

export function DeleteApiKeyDialog({
  open,
  onClose,
  apiKeyId,
  apiKeyName,
}: DeleteApiKeyDialogProps) {
  const deleteApiKey = useDeleteApiKey();

  const handleConfirm = async () => {
    try {
      await deleteApiKey.mutateAsync(apiKeyId);
      onClose();
    } catch (error) {
      console.error("Failed to delete API key:", error);
      toast.error("Failed to delete API key");
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={(open) => !open && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete API Key</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogBody>
          <AlertDialogDescription>
            This action cannot be undone. This will permanently delete{" "}
            <strong>{apiKeyName}</strong> and remove all access associated with
            it.
          </AlertDialogDescription>
        </AlertDialogBody>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={deleteApiKey.isPending}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault();
              handleConfirm();
            }}
            disabled={deleteApiKey.isPending}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {deleteApiKey.isPending ? "Deleting..." : "Delete"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
